export type webengageFunction =
  | {
      track: (arg0: string, arg1: any) => void;
      user: {
        setAttribute: (arg0: string, arg1: any) => void;
        login: (arg0: string) => void;
      };
    }
  | undefined;

const defaultWebengage = {
  track: () => {},
  user: {
    setAttribute: () => {},
    login: () => {},
  },
};

export default (): webengageFunction => {
  try {
    //@ts-ignore
    if (!window.webengage && !document.webengage) {
      return defaultWebengage;
    }
    //@ts-ignore
    if (window.webengage?.track) {
      //@ts-ignore
      return window.webengage;
    }
    //@ts-ignore
    if (document.webengage.track) {
      //@ts-ignore
      return document.webengage;
    }
    return defaultWebengage;
  } catch (error) {
    console.error(error);
  }
};
